import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { UsersService } from '../../services/users.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  isLoading: boolean = false;
  newsletterForm: FormGroup = new FormGroup({
    email: new FormControl('')
  });

  constructor(private formBuilder: FormBuilder, private httpService: HttpService, private userService: UsersService) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.newsletterForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmitForm() {
    this.isLoading = true;
    this.httpService.subscribeNewsletter(this.newsletterForm.value).subscribe(
      (response: any) => {
        if (response.status == "success") {
          Swal.fire({
            icon: 'success',
            title: 'Excellent!',
            text: 'Vous serais désormains informé des nouveautés sur nos produits & services.',
          });
          this.newsletterForm.reset();
        }
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        if (error.error.message && error.error.message == 'EMAIL_ALREADY_EXISTE') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vous avez déjà souscrit à la newsletter.',
          })
        } else {
          this.isLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

}
